import { render, staticRenderFns } from "./SidebarSuperAdmin.vue?vue&type=template&id=d2f11a72&scoped=true&"
import script from "./SidebarSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarSuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSuperAdmin.vue?vue&type=style&index=0&id=d2f11a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f11a72",
  null
  
)

export default component.exports